import { render } from "./Keranjang.vue?vue&type=template&id=ed305834&scoped=true"
import script from "./Keranjang.vue?vue&type=script&lang=js"
export * from "./Keranjang.vue?vue&type=script&lang=js"

import "./Keranjang.vue?vue&type=style&index=0&id=ed305834&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed305834"]])

export default __exports__